import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState = {
  informations: {},
  isConnected: false,
  validation: {
    hasJoinedServer: false,
    hasValidatedRules: false,
    hasStayedLongEnough: false,
    isBlacklisted: false,
    disallowedVillagers: [],
  },
  fetchedValidation: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action) => {
      const newState = state;
      newState.isConnected = true;
      newState.informations = action.payload;
      newState.validation = initialState.validation;
      newState.fetchedValidation = false;
    },
    logout: (state) => {
      const newState = state;
      newState.isConnected = false;
      newState.informations = {};
      newState.validation = initialState.validation;
      newState.fetchedValidation = false;
    },
    validate: (state, action) => {
      const newState = state;
      newState.validation = action.payload;
      newState.fetchedValidation = true;
    },
  },
});

export const { login, logout, validate } = userSlice.actions;

export const selectItems = (state) => state.user.informations;

export default userSlice.reducer;
